const design = (
    <div>
        <h1>Figma</h1>
        <p>Welcome! Learn how to design your website to use in your projects!</p>
        <h2>🪑 Table of Contents</h2>
        <ol>
            <li>Building your moodboard with Pinterest</li>
            <li>Figuring out your fonts and colors</li>
            <li>Using Figma to block/build out your designs</li>
            <li>Importing your designs into code or whatever it may be</li>
        </ol>
        <h2>✏️ Moodboard Building with Pinterest</h2>
        <ul>
            <li>Why?</li>
            <ul>
                <li>Moodboard is a great way to plan out the ~vibes~ of your website/design. It's an easy way to get inspiration and figure out how and what you want in your designs.</li>
                <li>The algorithm for Pinterest is very good at giving you similar images with the same vibes/theme so it makes the mood-boarding process a lot easier!</li>
            </ul>
        </ul>
        <h3>Directions</h3>
        <ol>
            <li>Go to Pinterest <a href="https://www.pinterest.com/" target="_blank" rel="noreferrer">here</a></li>
            <li>Search for whatever you want (website designs, home page design, search bar design, whatever)</li>
            <ul>
                <li>If you see something you like, hover on the image, and a “Save” button should appear. Save it and create a mood board with whatever name you desire</li>
                <li>Should be intuitive but if not, here's a quick video of how! <a href="https://www.youtube.com/watch?v=tUuihZp8udY" target="_blank" rel="noreferrer">here</a></li>
            </ul>
        </ol>
        <h2>🅰️ Fonts and Colors </h2>
        <p>Making memorable designs is intentional with the fonts and colors you choose.</p>
        <p>Here is an interesting Fun Fact:</p>
        <ul>
            <li>Ever notice how almost all fast food places (Macdonalds, panda express, in-n-out) have the color red? When your brain sees red, it produces a sense of hunger!</li>
            <li>What about all the big tech companies (Meta, Twitter, LinkedIn, Zoom) using blue as their main color? Blue is seen as dependable and reliable.</li>
            <li>All your favorite products are very intentional with the colors they choose.</li>
        </ul>
        <p>IMPORTANT: The most important when it comes to design is if YOU think it looks good! Be confident in your choices!</p>
        <h3>Where do I find fonts? (for free)</h3>
        <p>Did you know all Berkeley students have free access to everything Adobe related?</p>
        <ul>
            <li><a href="https://fonts.adobe.com/" target="_blank" rel="noreferrer">Adobe Fonts</a></li>
            <li><a href="https://www.dafont.com/" target="_blank" rel="noreferrer">Da Font</a></li>
        </ul>
        <p>These are my favorite two websites to get fonts from, but you can literally search for “Free fonts” and a lot will show up. A good way to find inspiration is through your mood board or your favorite websites!</p>
        <h3>Where do I find colors?</h3>
        <ul>
            <li>Look through your mood board and see what main colors you choose. Think about how those colors make you feel. Does it address the feel of the product you are creating?</li>
            <li>A good rule of thumb for colors: 👍</li>
            <ul>
                <li>1-2 main colors</li>
                <li>1-3 accent colors (supporting colors)</li>
                <li>You don't want to have more than 3-4 colors because it gets overwhelming and takes away the attention from the product you are building!</li>
            </ul>
            <li>Color Palette generator: <a href="https://coolors.co/" target="_blank" rel="noreferrer">https://coolors.co/</a></li>
            <ul>
                <li>Good for experimenting with different vibes</li>
            </ul>
        </ul>
        <h2>✒️ Using Figma</h2>
        <p>This is where the fun begins!</p>
        <h3>What is Figma? <a href="https://figma.com/" target="_blank" rel="noreferrer">here</a></h3>
        <p>Think Adobe Illustrator, but a lot more approachable and made for website building, wireframing, and prototyping. A lot easier to use and super easy to learn (learning curve is literally a flat line, trust)</p>
        <ul>
            <li>You can sign up with Figma using your berkeley.edu email (free!) you can either use it on a browser or download it down to your laptop</li>
        </ul>
        <h3>Figma Tutorial (43 mins) <a href="https://www.youtube.com/watch?v=HZuk6Wkx_Eg" target="_blank" rel="noreferrer">https://www.youtube.com/watch?v=HZuk6Wkx_Eg</a></h3>
        <ul>
            <li>This video goes into depths more than it needs to design a good website, but it is very good.</li>
        </ul>
        <h3>Important parts to know in the video (from 1:02 to 21:20)</h3>
        <ol>
            <li>Figma interface overview</li>
            <li>Page & grid set-up</li>
            <li>Design the hero & navigation (this is a good part to do as a demo and follow along to get the feel of how to create shapes)</li>
        </ol>
        <h2>Using your designs 💃</h2>
        <p>After all that hard work, you can now implement your designs with code.</p>
        <ul>
            <li>On the right-side menu, you will find the options to export your designs as png/jpg and view the css</li>
            <li>How you want to use your designs is all up to you!</li>
            <li>Having a design is having a guide on where to put certain elements, be free and explore whatever you think works best!</li>
        </ul>
    </div>
)

export default design